import * as React from 'react';
import doLog from '../../common/log';
import IframeDialog from '../../common/dialog-iframe';
import { Icon } from '@alifd/next';
import './index.scss';

const { useState,useEffect } = React;

export default function Index ( props: any ) {
  const [visible,setVisible] = useState( false );
  const { i18n,shouldHideBuyerRight,buyerRightInfo,productId } = props;
  // 大促隐藏
  if ( shouldHideBuyerRight ) return null;
  if ( !buyerRightInfo ) return null;

  const { logo,name,viewMoreText,viewMoreUrl,levelId = -1,levelName } = buyerRightInfo;

  if ( !name ) return null;

  useEffect( () => {
    doLog( '/sc.details.commonLogs',`productId=${productId}&action=BenefitsExp`, 'EXP' );
  },[] )

  return (
    <div className="buyer-benefits">
      <dl className="buyer-benefits">
        <dt className="market-action-list__dt">{i18n["benefits.title"]}</dt>
        <dd className="market-action-list__dd benefits-dd">
          {/* 选出第一个 */}
          {levelId > 0 && <img className="golden-buyer-logo" src={logo} />}
          <span className="golden-buyer-first-benefit">
            {name}
          </span>
          {levelId === -1 ? <a onClick={() => {
              doLog( '/sc.details.commonLogs',`productId=${productId}&action=BenefitsClk` );
          }} href={`//passport.alibaba.com/icbu_login.htm?return_url=${encodeURIComponent( window?.location?.href )}`}>{levelName}<Icon type="arrow-right" size="xxs" /></a>
            : <a href="#" onClick={e => {
              e.preventDefault();
              setVisible( true );
              doLog( '/sc.details.commonLogs',`productId=${productId}&action=BenefitsClk` );
            }}>{viewMoreText}<Icon type="arrow-right" size="xxs" /></a>
          }
        </dd>
      </dl>
      <IframeDialog iframeUrl={viewMoreUrl} visible={visible} setVisible={setVisible} productId={productId} action="BenefitsDialog" />
    </div>
  );
}